import apiMiddleware from "../api/apiMiddleware";

export const activityBookings = async (page = 1, search = "") => {
  try {
    const response = await apiMiddleware.get(
      `/activity-bookings-supplier?page=${page}${search ? `&search=${encodeURIComponent(search)}` : ""}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
